import { render, staticRenderFns } from "./ViewGeoSwipeCount.vue?vue&type=template&id=595c6310"
import script from "./ViewGeoSwipeCount.vue?vue&type=script&lang=js"
export * from "./ViewGeoSwipeCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports